import type { QueryKey } from '@tanstack/react-query';

import { DISCOVER_TRACK_KEY, MY_GROUPS_KEY } from '@/constants/queryKeys';

/**
 * What goes stale once the user shares a sound: every circle feed (the new reco
 * shows first) and — circle-activity-order — the circle list, ordered by latest
 * activity, so the circle the sound went to moves up.
 */
export function keysAfterRecoShared(): QueryKey[] {
  return [DISCOVER_TRACK_KEY, MY_GROUPS_KEY];
}
